/*=========================================================================================
  File Name: themeConfig.js
  Description: Theme configuration
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - Clean Vue.js Dashboard Admin Template
  Author: Pixinvent
  Author URL: hhttp://www.themeforest.net/user/pixinvent
==========================================================================================*/

import appConfig from '@/../appConfig.js';

let colors = appConfig.colors;
let tour = appConfig.tour;

// CONFIGS
const themeConfig = {
	disableCustomizer : true,       // options[Boolean] : true, false(default)
	disableThemeTour  : tour && tour.enable ? false : true,        // options[Boolean] : true, false(default)
	footerType        : "static",    // options[String]  : static(default) / sticky / hidden
	hideScrollToTop   : false,       // options[Boolean] : true, false(default)
	mainLayoutType    : "vertical",  // options[String]  : vertical(default) / horizontal
	navbarColor       : colors.navbarColor,      // options[String]  : HEX color / rgb / rgba / Valid HTML Color name - (default: #fff)
	navbarType        : "floating",  // options[String]  : floating(default) / static / sticky / hidden
	routerTransition  : "zoom-fade", // options[String]  : zoom-fade / slide-fade / fade-bottom / fade / zoom-out / none(default)
	rtl               : false,       // options[Boolean] : true, false(default)
	sidebarCollapsed  : false,       // options[Boolean] : true, false(default)
	theme             : "light",     // options[String]  : "light"(default), "dark", "semi-dark"
  
	// Not required yet - WIP
	userInfoLocalStorageKey: "userInfo",
  
	appConfig: appConfig

	// NOTE: themeTour will be disabled in screens < 1200. Please refer docs for more info.
  }
  
  import Vue from 'vue'
  import Vuesax from 'vuesax'
  Vue.use(Vuesax, { theme:{ colors }, rtl: themeConfig.rtl })
  
  export default themeConfig